import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useSuccessToast } from "@/hooks/useSuccessToast";
import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import {
  HttpResponse,
  Interview,
  InterviewQueryParams,
  UpdateInterviewRequest,
} from "@/types";

export function useUpdateSetInterview({
  companyId,
  jobId,
  queryParams,
}: {
  companyId: string;
  jobId: string;
  queryParams: InterviewQueryParams;
}) {
  const queryClient = useQueryClient();
  const successToast = useSuccessToast();
  const queryString = misc.prepareQueryParams(queryParams).toString();

  return useMutation({
    mutationFn: async ({
      id,
      updateInterviewRequest,
    }: {
      id: number;
      updateInterviewRequest: UpdateInterviewRequest;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/interviews/${id.toString()}`;
      const res = await guacHttpClient.patch<
        Interview,
        HttpResponse<Interview>,
        UpdateInterviewRequest
      >(path, updateInterviewRequest);

      return res.data;
    },
    onSuccess: (updatedInterview) => {
      queryClient.setQueryData(
        ["interviews", companyId, jobId, queryString],
        (cachedData?: Interview[]) => {
          if (!cachedData) return cachedData;
          return cachedData.map((interview) =>
            interview.id === updatedInterview.id ? updatedInterview : interview,
          );
        },
      );

      // Rescheduling a screen moves the staffer's google calendar event, so just confirm it worked.
      if (updatedInterview.calendarEventUpdated) {
        successToast({
          description:
            "Calendar event successfully updated in your Google calendar!",
        });
      }
    },
  });
}
